import db from '../../utils/db'
import {get} from '../../utils/auth'

const tabs = {
  state: {
    cacheVueData: new Map()
  },
  mutations: {
    //页面需要缓存的数据，将加入map中
    set_cache_data(state, {key, data}) {
      state.cacheVueData.set(key,data)
    }
  },
  actions: {
    setCacheData ({commit, state}, data) {
      return new Promise((resolve) => {
        commit('set_cache_data', data)
      })
    }
  },
  getters: {
  }
}
export default tabs
